import { useMediaQuery, } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
export function usePhoneView(bp) {
    if (bp === void 0) { bp = 'xs'; }
    var theme = useTheme();
    return useMediaQuery(theme.breakpoints.down(bp), { noSsr: true });
}
//# sourceMappingURL=usePhoneView.js.map